import builder from "../builders/base";
export default {
  getContentForm: query =>
    builder()
      .setMethod("GET")
      .setUrl("contents")
      .build(true),

  updateContentForm: data =>
    builder()
      .setMethod("PATCH")
      .setUrl(`contents/send`)
      .setData(data)
      .build()
};



// WEBPACK FOOTER //
// ./src/services/modules/form.js